import { noddiAsync, URLKeys } from 'noddi-async';

/** The selected group's admin state and the query state needed to render it honestly. */
export const useIsGroupAdmin = (userGroupId: number | undefined, userId: number | undefined) => {
  const enabled = userGroupId != null && userId != null;
  const { data, error, isLoading } = noddiAsync.useGet({
    type: URLKeys.getPaginatedUserGroupMembers,
    input: { userGroupId, userId, isAdmin: true, pageSize: 1 },
    queryConfig: { enabled }
  });
  return {
    error,
    isLoading,
    isGroupAdmin: enabled ? (data ? data.results.length > 0 : undefined) : false
  };
};
